<template>
  <div>
    <el-dialog ref="varBindingModel" @open="handleOpen" @close="handleClose" width="60%" :visible.sync="modalShow" :title="title" :show-close="true" :close-on-click-modal="false"
               id="wholePage"
               :content-style="{padding: '20px'}" :title-style="{'font-weight': 'bolder'}" append-to-body>
      <div class="modeBtns">
        <el-button type="success" @click="add('if(,,)')" class="previewModeBtn">if</el-button>
        <el-button type="success" @click="add('sin()')" class="previewModeBtn">sin</el-button>
        <el-button type="success" @click="add('cos()')" class="previewModeBtn">cos</el-button>
        <el-button type="success" @click="add('tan()')" class="previewModeBtn">tan</el-button>
        <el-button type="success" @click="add('pow(,)')" class="previewModeBtn">pow</el-button>
        <el-button type="success" @click="add('abs()')" class="previewModeBtn">abs</el-button>
      </div>
      <div>
        <div id="right_menu">
          <draggable-dialog class="draggableDialog"
                            :closable="false"
                            width='100%'
                            top='0px'
                            position='fixed'
          >
            <template slot="header">
              脚本说明区
            </template>
            <template slot="content">
              <div>
  <!--              style="height: 700px"-->
                <div>
                  <div>
                    基本规则<br/>
                    1. 变量名统一用[]括起来。<br/>
                    2. 算术运算符：+ 、-、*、/、%<br/>
                    3. 逻辑运算符：&&、||、！<br/>
                    4. 比较运算符：=、&lt;、&lt;=、&gt;、&gt;=、!=<br/>
                    5. 位运算符：&、|、^、~<br/>
                    6. 小括号<br/>
                    7. 数字<br/>
                    8. 一些内置函数，IF(表达式1，表达式2，表达式3)、SIN(数值)、COS(数值)、TAN(数值)、POW(数值1，数值2)、ABS(数值)
                    <br/>
                    脚本格式：<br/>
                    简单的设置变量关系 [变量名] = 表达式<br/>
                    条件分支： [变量名] =<br/>
                    CASE<br/>
                    WHEN 表达式 THEN 表达式<br/>
                    WHEN 表达式 THEN 表达式<br/>
                    ELSE 表达式<br/>
                    END<br/>
                    表达式格式: [变量名]/数字/内置函数() + 运算符(算术、逻辑、比较均可) + [变量名]/数字/内置函数()
                  </div>
                </div>
              </div>
              <div style="clear: both;"></div>
            </template>
          </draggable-dialog>
        </div>
        <div id="content" @mouseup="myDown" @keyup.left="myDown" @keyup.right="myDown">
          <el-autocomplete
              cols="100"
              rows="20"
              type="textarea"
              id="input"
              class="inline-input"
              v-model="content"
              :fetch-suggestions="querySearch"
              placeholder="请输入内容"
              @select="handleSelect"
              :trigger-on-focus="false"
          ></el-autocomplete>
          <div :style='{marginTop: "5px"}'>
            <el-button @click="modalShow = false">取 消</el-button>
            <el-button type="primary" @click="confirmScript">确 定</el-button>
          </div>
        </div>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import CheckMixin from "@/components/ScriptComponents/Mixins/CheckMixin";
import DraggableDialog from "@/components/ProductComponents/CreateComponents/DraggableDialog";
import API from "../../../../config/api";
export default {
  name: "VarScript",    // 编写变量表达式的弹窗
  components: {
    DraggableDialog
  },
  props: {
    show: Boolean,
    event: Object,
    varList: Array,
    companyId: Number,
  },
  mixins:[CheckMixin],
  data() {
    return {
      title: "脚本（示例:[变量_0]=[变量_0]+[变量_4]*2）",
      content: '',
      l: "",
      r: "",
      pos: "",
      cb_tmp: "",
      tmp_content: '',
      datas: [],    // 用来提示的变量列表
      state: 0,
      updateVariableId: "",
      updateVariable: "",
      variableList: [],   // 变量列表
      variableIdList: [],  // 变量id列表
      TriggerVariableIds: "",
      resState: -1,
    }
  },
  mounted() {
    //console.log("varlist",this.varList)
    for (let i = 0; i < this.varList.length; i++) {
      let value = "[" + this.varList[i].name + "]"
      let data = {
        "value": value
      }
      this.datas.push(data)
      this.variableList.push(this.varList[i].name.toLowerCase())
      this.variableIdList.push(this.varList[i].id);
    }
    this.content = this.event.content
  },
  updated() {
    // 页面更新后根据state的状态,看看要不要设置光标的位置
    if (this.state === 1) {
      this.state = 0
      this.setCaretPosition(document.getElementById("input"), this.l)
    }
  },
  methods: {
    handleOpen(){
      this.$bus.$emit("handle-stop-wrapper-click-listening");
    },
    handleClose(){
      this.$bus.$emit("handle-continue-wrapper-click-listening");
    },
    //鼠标按下事件
    myDown() {
      if (this.cb_tmp !== '') this.cb_tmp([]);
      this.pos = this.getCursorPosition(document.getElementById("input"));
    },
    add(text) {
      //this.pos = this.getCursorPosition(document.getElementById("input"));
      //console.log("点击了添加")
      let v1 = this.content.substring(0, this.pos);  // 切割左右端点
      let v2 = this.content.substring(this.pos);
      this.pos += text.length
      this.content = v1 + text + v2;
    },
    querySearch(queryString, cb) {
      this.cb_tmp = cb;
      this.tmp_content = this.content
      let pos = this.getCursorPosition(document.getElementById("input"));
      this.pos = pos;
      // 若选择了建议文本,更新的右端点就在现在这里
      this.r = pos
      let i = this.r - 1;
      let flag = 0
      while (i >= 0 && queryString[i] !== '[') {
        if (queryString[i] === ']') flag = 1;
        i--;
      }
      if (i < 0 || flag === 1) {
        cb([]);
        return
      }
      // 找左端点,必须有[
      this.l = i;
      // 用这一小段来查询
      queryString = queryString.substring(this.l, this.r);
      let datas = this.datas;
      let results = queryString ? datas.filter(this.createFilter(queryString)) : datas;
      // 调用 callback 返回建议列表的数据
      cb(results);
    },
    createFilter(queryString) {
      return (data) => {
        return (data.value.toLowerCase().indexOf(queryString.toLowerCase()) === 0);
      };
    },
    handleSelect(item) {
      this.content = this.tmp_content    // 选择了之后content就变了,重新回到原来的样子
      let v1 = this.content.substring(0, this.l);  // 切割左右端点
      let v2 = this.content.substring(this.r);
      // console.log(v1,v2,this.l,this.r)
      this.content = v1 + item.value + v2;    // 更新现在的内容
      this.l += item.value.length
      this.state = 1
    },
    // 获得光标位置
    getCursorPosition(element) {
      let cursorPos = 0;
      // IE浏览器
      if (document.selection) {
        var selectRange = document.selection.createRange();
        selectRange.moveStart('character', -element.value.length);
        cursorPos = selectRange.text.length;
      } else if (element.selectionStart || element.selectionStart == '0') {
        cursorPos = element.selectionStart;
      }
      return cursorPos;
    },
    // 设置光标位置
    setCaretPosition(textDom, pos) {
      if (textDom.setSelectionRange) {
        // IE Support
        textDom.focus();
        textDom.setSelectionRange(pos, pos);
      } else if (textDom.createTextRange) {
        // Firefox support
        var range = textDom.createTextRange();
        range.collapse(true);
        range.moveEnd('character', pos);
        range.moveStart('character', pos);
        range.select();
      }
    },

    confirmScript() {
      this.content = this.pre_done(this.content);
      this.getUpdateInfo(this.content);
      let res = this.check(this.content,this.variableList)
      if (res !== "未发现问题") {
        this.$message({
          message: res,
          type: 'warning',
        })
        return
      }
      this.excuteScript()
    },
    excuteScript() {
      let header = {
        "Content-Type": "application/x-www-form-urlencoded"
      }
      let data = {
        companyId: this.companyId,
        updateVariableId: this.updateVariableId,
        scriptSource: encodeURIComponent(this.content),
        TriggerVariableIds: this.TriggerVariableIds + ",",
        executeStatus: 0,
      }
      this.$axiosRequest({
        url: API.executeEventScript,
        method: 'POST',
        data: data,
        header: header,
        success: res => {
          if (res.data == -3) {
            this.$message({
              message: '脚本语法错误！',
              type: 'error',
            })
          } else if (res.data == -2) {
              this.$message({
                message: '参数不完整！',
                type: 'error',
              })
            } else if (res.data == -1) {
              //console.log("系统错误")
              this.$message({
                message: '系统错误',
                type: 'error',
              })
            } else if (res.data > 0) {
              this.$message({
                message: '编写成功！',
                type: 'success',
            })
            this.$emit("setInfo",this.content,this.updateVariableId,this.TriggerVariableIds)
            this.modalShow = false
          }
        }
      });
    },
    getUpdateInfo(content) {    // 获取更新的变量id和值
      content = content.replace(/\n/g, " ").toLowerCase().trim();
      let id = content.indexOf("=");
      if (id === -1) return;
      let pre = content.substr(0, id).trim()
      this.updateVariable = pre.substr(1,pre.length-2)
      for (let i = 0; i < this.variableList.length; i++) {
        if (this.updateVariable.toLowerCase() === this.variableList[i]) {
          this.updateVariableId = this.variableIdList[i];
        }
      }
    },
  },
  computed: {
    modalShow: {      // 对话框是否展示,修改这个值时把父组件的show值也修改了
      get() {
        return this.show
      },
      set(val) {
        this.$emit("close", val)
      }
    }
  },
}
</script>

<style lang="less" scoped>
#wholePage {
  #content {
    position: relative;
    height: 55vh;
    //float: left;
    background-color: #ffffff;
    width: 70%;
    //overflow-y: scroll;
  }

  #right_menu {
    position: relative;
    height: 55vh;
    width: 30%;
    float: right;
    background-color: #ececec;
    //overflow-y: scroll;
  }


  .modeBtns {
    height: 7%;
    width: 100%;
    margin-bottom: 5px;
    background-color: #FFFFFF;
    display: flex;
    justify-content: space-around;
    align-items: flex-start;
    transition: opacity 0.5s;
    z-index: 99999;
    &:hover {
      opacity: 1;
    }

    el-button {
      width: 8%;
    }

  }
}
</style>